import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { IQuota, IQuotaCompletes } from '../../models/IQuota';
import { ITotalKey } from '../../models/ITotalKey';
import { Utils } from '../../Utils'
@Component({
  selector: 'panel-share-viewer',
  templateUrl: './panel-share-viewer.component.html',
  styleUrls: ['./panel-share-viewer.component.css']
})
export class PanelShareViewerComponent implements OnInit {
  @Input() panelName: string;
  @Input() totalCompletes: IQuotaCompletes;
  @Input() suggestedFDs: Array<string>;
  @Input() requestedCompletes: number;
  @Input() editMode: boolean;
  @Input() toolTip: boolean;
  @Input() showClicks: boolean;
  @Input() clicks: number; 
  @Output() onTotalUpdated = new EventEmitter<ITotalKey>();
  completeLabels: string[];
  showData: boolean;
  suggestedFDSet: Set<string>;
  constructor() { }

  ngOnInit() {
    this.setup();
  }

  ngOnChanges(changes) {
    this.setup();
  }

  isHighlighted(label) {
    return this.suggestedFDSet.has(label);
  }

  setup() {
    this.suggestedFDSet = new Set(this.suggestedFDs);
    this.showData = false;
    this.completeLabels = [];
    for (let key in this.totalCompletes) {
      this.completeLabels.push(key);
      this.showData = true;
    }
    this.completeLabels = this.completeLabels.sort(Utils.sortCompleteLabels);
  }

  onChangedValues(label: string){
    //they updated the totals for this key.  we need to broadcast the new value & the label
    const itot: ITotalKey = { value: this.totalCompletes[label], totalKey: label };
    this.onTotalUpdated.emit(itot);
  }

  onQuotaChangedValues(label: string) {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/panel-share-viewer/panel-share-viewer.component.ts